/**
 * Which store did this binary come from?
 *
 * Zenith ships to Google Play and the Apple App Store — one store per platform —
 * so the answer is fully DERIVED from the platform. Nothing has to be compiled
 * in, and there is nothing to get wrong at build time.
 *
 * WHY THIS MODULE STILL EXISTS
 * ---------------------------
 * The backend's policy is keyed by (platform, store), so the gate has to send a
 * store. Keeping that mapping in one named place means adding a second channel
 * for a platform later is a change here rather than a change threaded through
 * the gate.
 *
 * It previously read a compiled-in REACT_APP_STORE, because Huawei AppGallery
 * was modelled as a third store and an Android build genuinely could not tell
 * which of the two it came from (Capacitor's getPlatform() only says "android").
 * That is gone: with a single Android channel the variable could only ever
 * restate what the platform already says, while adding a way for a build to
 * claim the wrong one.
 *
 * If a second store per platform is ever added, this has to become an assertion
 * again — something baked into the binary, or read from the installer package
 * name via a native plugin. The backend is already built for it: a client whose
 * store it cannot trust is treated as store-less, and a store-less Android
 * client is only blocked when every Android bucket agrees.
 */

const STORE_BY_PLATFORM = {
  ios: "appstore",
  android: "play",
};

/**
 * The store to report for a Capacitor platform.
 * Returns null on web, where there is no store and no gate.
 */
export function resolveStore(platform) {
  return STORE_BY_PLATFORM[platform] ?? null;
}

export { STORE_BY_PLATFORM };
